import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { useAuthStore } from "../../../../../console/store/useAuthStore";
import useToastStore from "../../../../../console/store/useToastStore";
import { enum_api_uri } from "../../../utils/enum";

interface ApiResponse {
    status: string;
    message: string;
}

export const useDeleteGoodsCategory = (successCallback?: () => void) => {
    const queryClient = useQueryClient();
    const accessToken = useAuthStore(state => state.accessToken);

    return useMutation<ApiResponse, Error, number>({
        mutationFn: async (categoryIdx: number) => {
            const response = await axios.delete(`${enum_api_uri.delete_product_category}/${categoryIdx}`, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });

            return response.data;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["getGoodsCategory"] });
            successCallback?.();
        },
    });
};
